// Third-party Library 
import { Tabs } from 'antd';
import { useSelector } from "react-redux";
import { UnorderedListOutlined,FileOutlined } from '@ant-design/icons'

import { ListView, FileView } from "./components";

// Services Library
import { REDUX as REDUX_UTIL } from "../../services/util";

// Styles 
import classes from "../../pages/index.module.css";

const { reduxStoreWrapper } = REDUX_UTIL;

const payroll = (props) => {
  const user = useSelector(reduxStoreWrapper("user"));
  const { uroleid } = user;

  const items = [
    {
        key: '1',
        label: (<span><UnorderedListOutlined/> List View</span>),
        children: <ListView/>,
    },
    {
        key: '2',
        label: (<span><FileOutlined /> File View</span>),
        children: <FileView />
    },
  ];

  return (
    <div className={classes.container}>
      {uroleid === "A" ? 
        <>
          <Tabs defaultActiveKey="1" items={items} 
            tabBarStyle={{position: 'absolute', width: '80vw', zIndex: 5, backgroundColor: 'white', marginTop: '-1.4rem', paddingBottom:'1rem', paddingTop: '0.5rem'}}
          />
        </> : 
        <>
          <ListView/>
        </>
      }
    </div>
  )
} 

export default payroll;